import React from 'react';

import { Icon } from '@chakra-ui/react';

export const PolicyPasswordIcon = props => (
  <Icon viewBox="0 0 723 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-278 0)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M400.145 642.001 400.145 78C400.145 68.0588 408.204 60 418.144 60L767.692 60C772.463 60 777.041 61.8964 780.416 65.2721L874.874 159.728C878.249 163.104 880.145 167.682 880.145 172.456L880.145 642.001C880.145 651.942 872.087 660 862.144 660L418.144 660C408.204 660 400.145 651.942 400.145 642.001Z"
                stroke="currentColor"
                strokeWidth="20.0126"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1.00076 0 0 1 -1.06613 0)"
              />
              <path
                d="M760.145 162 760.145 70.6065C760.145 64.7488 764.893 60 770.752 60 773.565 60 776.262 61.1174 778.255 63.1066L877.039 161.894C879.028 163.882 880.145 166.58 880.145 169.393 880.145 175.251 875.398 180 869.536 180L778.144 180C768.204 180 760.145 171.941 760.145 162Z"
                stroke="currentColor"
                strokeWidth="20.0126"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                strokeOpacity="1"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1.00076 0 0 1 -1.06613 0)"
              />
              <path
                d="M269.967 202.172 286.915 185.224 242.122 140.431 171.907 210.646C165.854 207.015 158.59 205.804 151.327 205.804 128.325 205.804 108.955 225.174 108.955 248.176 108.955 271.177 128.325 290.547 151.327 290.547 174.328 290.547 193.698 271.177 193.698 248.176 193.698 240.912 191.277 233.648 188.855 227.595L211.857 204.593 239.701 232.437 256.65 215.489 228.806 187.645 242.122 174.328 269.967 202.172ZM151.327 266.335C141.642 266.335 133.167 257.86 133.167 248.176 133.167 238.491 141.642 230.016 151.327 230.016 161.011 230.016 169.486 238.491 169.486 248.176 169.486 257.86 161.011 266.335 151.327 266.335Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1 0 0 1.00024 494.144 214.691)"
              />
              <path
                d="M24.2122 230.016C24.2122 182.803 61.7412 145.273 108.955 145.273 133.167 145.273 156.169 156.169 173.118 174.328L191.277 158.59C180.381 146.484 168.275 136.799 153.748 130.746 170.696 117.429 181.592 95.6382 181.592 72.6367 181.592 32.6865 148.905 0 108.955 0 69.0049 0 36.3183 32.6865 36.3183 72.6367 36.3183 95.6382 47.2139 117.429 65.373 130.746 26.6335 147.695 0 185.224 0 230.016L0 290.547 96.849 290.547 96.849 266.335 24.2122 266.335 24.2122 230.016ZM60.5307 72.6367C60.5307 46.0033 82.3217 24.2122 108.955 24.2122 135.588 24.2122 157.379 46.0033 157.379 72.6367 157.379 99.2701 135.588 121.061 108.955 121.061 82.3217 121.061 60.5307 99.2701 60.5307 72.6367Z"
                fill="currentColor"
                fillRule="nonzero"
                fillOpacity="1"
                transform="matrix(1 0 0 1.00024 494.144 214.691)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
